<template>
  <div class="container-fluid bg-dark pb-5">
    <flipbook v-slot="flipbook" :numPages="images.length"
              :page="1"
              :pages="images"
              class="col-12 border-1 flipbook overflow-hidden">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <p class="text-white">{{ file_name }}</p>
        </div>
        <div class="py-2 d-flex justify-content-end align-items-center">
          <div>
            <button class="btn btn-sm btn-secondary mr-2"
                    @click="flipbook.flipLeft"
                    :disabled="flipbook.page===1"
            >
              <font-awesome-icon icon="chevron-left"></font-awesome-icon>
            </button>
            <button class="btn btn-sm btn-secondary mr-2" @click="flipbook.zoomIn">
              <font-awesome-icon icon="magnifying-glass-plus"></font-awesome-icon>
            </button>
          </div>
          <div class="ml-2 mr-2 text-white">
            Page {{ flipbook.page }} of {{ flipbook.numPages }}
          </div>
          <div>
            <button class="btn btn-sm btn-secondary mr-2" @click="flipbook.zoomOut">
              <font-awesome-icon icon="magnifying-glass-minus"></font-awesome-icon>
            </button>
            <button class="btn btn-sm btn-secondary mr-2"
                    :disabled="flipbook.page===flipbook.numPages-1 || flipbook.page===flipbook.numPages"
                    @click="flipbook.flipRight">
              <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            </button>
          </div>
        </div>
        <div>
          <button class="btn btn-sm btn-secondary" @click="goBack">
            <font-awesome-icon class="mr-2" icon="chevron-left"></font-awesome-icon>
            Go Back
          </button>
        </div>
      </div>
    </flipbook>
  </div>

</template>

<script>
import Flipbook from 'flipbook-vue'
import * as book from '../service/pdfjsinit.service'
import {mapActions} from "vuex";
import {FileService} from "@/service/file.service";
import {AppMixins} from "@/mixins/app.mixins";
export default {
  data() {
    return {
      images: [],
      file_name: ''
    }
  },
  components: {Flipbook},
  mixins:[AppMixins],
  async created() {
    await this.testPdfGen()
  },
  methods: {
    ...mapActions([
      'getCircularAttachmentFile',
      'getCircularFile'
    ]),

    async testPdfGen() {
        const response = this.$route.params.type==='circular' ?
            await this.getCircularFile(parseInt(this.$route.params.id)  )
            : await this.getCircularAttachmentFile(parseInt(this.$route.params.id) )
      const fileUrl = FileService.getFileUrl(response.file);
        // console.log(fileUrl);
      this.file_name = response.file_name
      this.images = book.init(fileUrl);
    }
  }

}
</script>

<style scoped>
.flipbook {
  width: 100vw;
  height: 100vh;
}
</style>
